import PostcoderAddress from './PostcoderAddress';

const searchButtonId = 'btn_search'
const searchButton = document.getElementById(searchButtonId);

if(searchButton) {
    new PostcoderAddress({
        apikey: "PCWDK-UPGEX-YDE2R-TKCRW",
        searchterm: "#txt_search", // Query selector of the searchterm input field
        //suggestions: "#suggestion_list", // Query selector for preview datalist
        addressselectioncontainer: "#address_selection_container", // Container for the address selection drop down
        noresultmessage: "#no_result_message",
        country: "#txt_country", // Country select list; leave blank if not using a country select list
        countrycode: "GB", // Hard code if not using a country select list; leave blank otherwise
        searchbutton: `#${searchButtonId}`,
        //organisation: "", // Leave blank if form does not have a separate organisation field
        addressline1: "#street_1",
        addressline2: "#street_2", // Leave blank if form does not have an addressline2
        //addressline3: "", // Leave blank if form does not have an addressline3
        //addressline4: '',  // Leave blank if form does not have an addressline4
        county: "#county", // Leave blank if form does not have a county
        posttown: "#towncity",
        postcode: "#postcode",
        number: "#address_building_number",
        premise: "#address_building_name",
        uniquedeliverypointreferencenumber: '#udprn'
    });
}


// Setup hidden field updates
const address_name_number = document.getElementById('address_name_number');
const address_building_name = document.getElementById('address_building_name');
const address_building_number = document.getElementById('address_building_number');

if(address_name_number && address_building_name && address_building_number) {
    address_name_number.addEventListener('change', e => {
        const intValue = parseInt(address_name_number.value)
        address_building_name.value = isNaN(intValue) ? address_name_number.value : ''
        address_building_number.value = isNaN(intValue) ? '' : address_name_number.value
    })
}


